import React from "react";
import './Nav.css';
import Footer from '../footer/Footer';
import DLBtn from '../dark-light-mode/DLBtn';

function Nav() {
    return(
        <nav>
            <div className="nav-main-hold">

                <div className="nav-logo-div">
                    <h2>Box-Shadow Tool</h2>
                </div>

                <div className="nav-content-div" id="link-div">

                    <div className="menu-content-hold">
                    <h2>CSS Box-Shadow Generator</h2>
                    <Footer />
                    </div>
                    
                </div>

                <div className="nav-btn-div">
                    <div className="menu-btn-div" onClick={
                        function addClassOnClick() {
                            console.log("Nav button is clicked")
                            const linkDiv = document.getElementById("link-div");
                            linkDiv.classList.toggle("addLINK")
                            const linkIcon = document.getElementById("btn-icon-i");
                            linkIcon.classList.toggle("addIcon")
                        }}>
                        <i className="fas fa-bars" id="btn-icon-i"></i>
                    </div>
                    <DLBtn />
                </div>
            </div>
        </nav>
    );
}

export default Nav;